import request from '@/utils/request'

// 获取 API_KEY 列表
// service_id   服务ID
export function getApiKeyList(data) {
  return request({
    url: '/api/ai/apikey/getApiKeyList',
    method: 'post',
    data
  })
}


// 创建API_KEY
// service_id   服务ID
// mnemonic     助记词，长度 3-30
export function createApiKey(data) {
  return request({
    url: '/api/ai/apikey/createApiKey',
    method: 'post',
    data
  })
}


// 删除API_KEY
// mnemonic     助记词，长度 3-30
export function deleteApiKey(data) {
  return request({
    url: '/api/ai/apikey/deleteApiKey',
    method: 'post',
    data
  })
}
